<template>
    <div class="main-container">
        <div :class="'container-password is-' + $device">
            <span class="fs-18 black fw-600" style="display: block"> กรุณากรอกรหัสเปิดตั๋วอิเล็กทรอนิกส์ </span>
            <!-- <span class="fs-18 red fw-600" style="display: block"> คอนเสิร์ตมหัศจรรย์ รักไม่รู้จบ </span> -->
            <br />
            <!-- <span class="fs-14 black" style="display: block"> กรุณากรอกรหัสเปิดไฟล์ตั๋วอิเล็กทรอนิกส์ </span>
        <br /> -->
            <div class="dots-width">
                <span
                    class="dot animated"
                    :style="{
                        'margin-left': 0,
                        'background-color': password.length > 0 ? '#cc0000' : 'transparent',
                    }"
                ></span>
                <span
                    class="dot animated"
                    :style="{
                        'background-color': password.length > 1 ? '#cc0000' : 'transparent',
                    }"
                ></span>
                <span
                    class="dot animated"
                    :style="{
                        'background-color': password.length > 2 ? '#cc0000' : 'transparent',
                    }"
                ></span>
                <span
                    class="dot animated"
                    :style="{
                        'background-color': password.length > 3 ? '#cc0000' : 'transparent',
                    }"
                ></span>
            </div>
            <div class="center1">
                <div class="pinC animated bounceInUp">
                    <div class="pinB" nr="1" @click="onPinPress(1)">
                        <label class="pin_T">1</label>
                    </div>
                    <div class="pinB" nr="2" @click="onPinPress(2)">
                        <label class="pin_T">2</label>
                    </div>
                    <div class="pinB" nr="3" @click="onPinPress(3)">
                        <label class="pin_T">3</label>
                    </div>
                    <div class="pinB" nr="4" @click="onPinPress(4)">
                        <label class="pin_T">4</label>
                    </div>
                    <div class="pinB" nr="5" @click="onPinPress(5)">
                        <label class="pin_T">5</label>
                    </div>
                    <div class="pinB" nr="6" @click="onPinPress(6)">
                        <label class="pin_T">6</label>
                    </div>
                    <div class="pinB" nr="7" @click="onPinPress(7)">
                        <label class="pin_T">7</label>
                    </div>
                    <div class="pinB" nr="8" @click="onPinPress(8)">
                        <label class="pin_T">8</label>
                    </div>
                    <div class="pinB" nr="9" @click="onPinPress(9)">
                        <label class="pin_T">9</label>
                    </div>
                    <div class="pinB"></div>
                    <div class="pinB" nr="0" @click="onPinPress(0)">
                        <label class="pin_T">0</label>
                    </div>
                    <div class="pinB pDelete" @click="onPinPress('del')">
                        <label class="pin_T pDelete">ลบ</label>
                    </div>
                </div>
            </div>
            <a-button size="large" class="text-center primary-btn ant-button-label-custom" style="width: 47.5%" :loading="loading" @click="onConfirm">
                <strong class="fs-18">{{ $t('Confirm') }}</strong>
            </a-button>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :step="modal_step" @on-save="onModalSave" @on-cancel="onModalCancel" />
        </div>
    </div>
</template>
<script>
import modalForm from './modalForm';
import store from 'store';
export default {
    components: {
        modalForm,
    },
    data: function () {
        return {
            password: '',
            modal_visible: false,
            modal_step: null,
            key: this.$route.params.key,
            ticket_data: null,
        };
    },
    mounted() {},
    methods: {
        onPinPress(pin) {
            if (pin == 'del') this.password = this.password.slice(0, -1);
            else if (this.password.length >= 4) return false;
            else this.password += String(pin);
        },
        onConfirm(e = null) {
            if (e) e.preventDefault();
            this.modal_step = null;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/share/ticket',
                    data: {
                        key: this.key,
                        password: this.password,
                    },
                    callback: (res) => {
                        var self = this;
                        if (res && res.result == 'errors') {
                            this.modal_visible = true;
                            this.modal_step = 'wrong_password';
                            console.log('his.modal_visible', this.modal_visible);
                            console.log('his.modal_visible', this.modal_step);
                        } else {
                            this.ticket_data = res.complete;
                            self.onModalCancel();
                        }
                    },
                },
            });
        },
        onModalSave() {},
        onModalCancel() {
            this.modal_visible = false;
            if (this.modal_step == 'wrong_password') {
                this.password = '';
            } else {
                if (this.ticket_data && this.ticket_data.ticket_list && this.ticket_data.ticket_list[0]) {
                    var url = '/ticket-layout-' + this.ticket_data.ticket_list[0].ticket_template;
                    // var ticket_data = this.ticket_data;
                    store.set('password_ticket', this.password);
                    store.set('key_ticket', this.key);
                    // this.$router.replace({ path: url, query: { ticket_data } });
                    this.$router.replace({ path: url });
                }
            }
        },
    },
};
</script>
<style scoped>
.navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    /* height: 40px; */
    /* height: 10vh; */
    height: 48px;
    padding: 0 8px;
    z-index: 2;
}
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.center1 {
    /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
}
.center2 {
    text-align: center;
}
.pinRC {
    display: none;
}
.pinC {
    display: block;
    position: relative;
    width: 270px;
    height: 220px;
    margin: 0 auto;
}
.pinC > .pinB {
    position: relative;
    float: left;
    width: calc(270px / 3);
    height: calc(220px / 3);
    text-align: center;
    /* line-height: 3; */
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty) {
    /* background-color: #dcdcdc; */
    background-color: transparent;
    border: 2px solid #ffffff;
}
.pinC > .pinB:not(.empty):hover {
    /*     border: 2px dotted #fefefe; */
    cursor: pointer;
}
.pinC > .pinB:not(.empty)::before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB:not(.empty):active::before {
    background-color: rgba(200, 200, 200, 0.45);
}
.pinC > .pinB > .pin_T {
    /* position: absolute;
  width: 100%;
  left: 0%;
  height: 100%; */
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-size: 26px;
    font-weight: 600;
}
.pin_T.pDelete {
    font-weight: 300 !important;
}
.pinC > .pinB > .pin_t {
    font-size: 75%;
    position: absolute;
    bottom: -5px;
    left: 50%;
    color: darkgrey;
    transform: translate(-50%, 0);
}
.pinC > .pinB.input > .pinpart {
    border: 2px solid #000000;
    border-radius: 50%;
    float: left;
    width: 10px;
    height: 10px;
    position: relative;
    top: calc(50% - 5px);
    margin-left: 4.5px;
    background-color: rgba(100, 100, 100, 0);
    /* background-color: transparent; */
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.pinC > .pinB.input > .pinpart.active {
    background-color: #000000;
}
.confirmed {
    animation: removec ease-out 1s;
    animation-iteration-count: 1;
    transform-origin: 0% 50%;
    animation-fill-mode: forwards;
    /*when the spec is finished*/
    -webkit-animation: removec ease-out 1s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 0% 50%;
    -webkit-animation-fill-mode: forwards;
    /*Chrome 16+, Safari 4+*/
    -moz-animation: removec ease-out 1s;
    -moz-animation-iteration-count: 1;
    -moz-transform-origin: 0% 50%;
    -moz-animation-fill-mode: forwards;
    /*FF 5+*/
    -o-animation: removec ease-out 1s;
    -o-animation-iteration-count: 1;
    -o-transform-origin: 0% 50%;
    -o-animation-fill-mode: forwards;
    /*Not implemented yet*/
    -ms-animation: removec ease-out 1s;
    -ms-animation-iteration-count: 1;
    -ms-transform-origin: 0% 50%;
    -ms-animation-fill-mode: forwards;
    /*IE 10+*/
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
@keyframes removec {
    0% {
        opacity: 1;
        transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        transform: translate(0px, 0px) scaleX(0);
    }
}
@-moz-keyframes removec {
    0% {
        opacity: 1;
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -moz-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -moz-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -moz-transform: translate(0px, 0px) scaleX(0);
    }
}
@-webkit-keyframes removec {
    0% {
        opacity: 1;
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -webkit-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -webkit-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -webkit-transform: translate(0px, 0px) scaleX(0);
    }
}
@-o-keyframes removec {
    0% {
        opacity: 1;
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -o-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -o-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -o-transform: translate(0px, 0px) scaleX(0);
    }
}
@-ms-keyframes removec {
    0% {
        opacity: 1;
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    20% {
        opacity: 1;
        -ms-transform: translate(0px, 10px) scaleX(1);
    }
    25% {
        -ms-transform: translate(0px, 0px) scaleX(1);
    }
    27% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
    100% {
        opacity: 0;
        -ms-transform: translate(0px, 0px) scaleX(0);
    }
}
.dots-width {
    width: 100%;
    margin: 0 auto;
}
.dot {
    border: 2px solid #bbb;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: inline-block;
    margin-left: 20px;
}
.footer-label {
    padding: 0;
    font-weight: 300;
    color: #cc0000;
    margin-top: 12px;
}
.เข้าใช้งานด้วยหมายเลขสมาชิกอื่น {
    text-align: left;
    width: 60%;
}
.ลืมรหัส {
    text-align: right;
    width: 40%;
}
.container-password {
    padding: 20px 16px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    /* width: 90%; */
    width: 360px;
    background-color: #fff !important;
    border-radius: 0;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container-password.is-desktop,
.container-password.is-tablet {
    /* width: auto; */
    width: 360px;
}
.container_forgot_password {
    padding: 8px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 360px;
    background-color: #fff !important;
    border-radius: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container_forgot_password.is-desktop,
.container_forgot_password.is-tablet {
    width: 360px;
}
.container_forgot_member {
    padding: 8px;
    text-align: center;
    border: unset;
    box-shadow: unset !important;
    width: 360px;
    background-color: #fff !important;
    border-radius: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.container_forgot_member.is-desktop,
.container_forgot_member.is-tablet {
    width: 360px;
}
@media (max-device-width: 413px) and (max-device-height: 843px) {
    .pinC {
        width: 270px;
        height: 220px;
    }
    .pinC > .pinB {
        width: calc(270px / 3);
        height: calc(220px / 3);
    }
    .pinC > .pinB > .pin_T {
        font-size: 25px;
    }
    .container-password {
        width: 330px;
    }
    .container_forgot_member {
        width: 330px;
    }
}
@media (max-device-width: 374px) and (max-device-height: 843px) {
    .dots-width {
        width: 80%;
    }
    .dot {
        width: 15px;
        height: 15px;
        margin-left: 10px;
    }
    .pinC {
        width: 250px;
        height: 200px;
    }
    .pinC > .pinB {
        width: calc(250px / 3);
        height: calc(200px / 3);
    }
    .pinC > .pinB > .pin_T {
        font-size: 25px;
    }
    .container-password {
        /* width: 280px !important; */
        width: 100% !important;
    }
    .container_forgot_member {
        /* width: 280px !important; */
        width: 100% !important;
    }
}
@media screen and (max-width: 1200px) {
    .col-xl-6 {
        width: 50%;
    }
}
@media (max-device-width: 15360px) and (max-device-height: 1080px) {
    .container-password {
        position: relative;
        left: unset;
        top: unset;
        -webkit-transform: unset;
        transform: unset;
        margin: 0 auto;
    }
}
</style>